
import { Observable } from '../../Observable';
import { letProto } from '../../operator/let';

Observable.prototype.let = letProto;
Observable.prototype.letBind = letProto;

declare module '../../Observable' {
  interface Observable<T> {
    let: typeof letProto;
    letBind: typeof letProto;
  }
}


// WEBPACK FOOTER //
// ../../../src/add/operator/let.ts